import { Flex } from "antd";
import { FC } from "react";
import { Market, TaskDMP } from "tm-shared/types";

import { SubtaskCard } from "@/components/TasksModals/components/SubtaskCard";

import { CustomTaskFromTaskButton } from "../components/CustomTaskFromTaskButton";
import { TaskViewModal } from "../TaskViewModal";

interface DmpViewModalProps {
    task: TaskDMP;
    market: Market;
    onClose: () => void;
}

export const DmpViewModal: FC<DmpViewModalProps> = ({
    task,
    market,
    onClose,
}) => {
    const taskPayload = task.payload;
    const completedAt = task?.completedAt;

    if (!taskPayload || !completedAt) return null;

    const dmp = task.context.dmp;
    const taskImages = Object.values(taskPayload).flatMap(
        ({ photos }) => photos,
    );

    return (
        <TaskViewModal title={task.name} onClose={onClose} taskInfo={task.info}>
            <Flex vertical gap={16}>
                <CustomTaskFromTaskButton
                    task={task}
                    market={market}
                    images={taskImages}
                />
                {dmp.map(({ subtaskId, name }) => {
                    const subtaskPayload = taskPayload[subtaskId];

                    if (!subtaskPayload) return null;

                    return (
                        <SubtaskCard
                            key={subtaskId}
                            subtask={subtaskPayload}
                            title={name}
                        />
                    );
                })}
            </Flex>
        </TaskViewModal>
    );
};
